<template>
  <div>
    <div v-show="false"> {{getSearchResultsCounter}} </div>
    <div v-if="this.getSearchResults.length === 0">
      <v-layout row class="mt-4 align-center justify-center row fill-height">
        <v-card :class="ui.bkgdColor" :max-width="ui.cardMinWidth">
          <v-card-title primary-title>
            <v-layout row>
              <v-icon left :class="ui.chipColor"> warning </v-icon>
              <a :class="ui.textTitle">
                Register
              </a>
            </v-layout>
          </v-card-title>
          <v-layout row class="ml-4 mr-4  mb-4 mt-4">
            <a :class="ui.textSubheading">
              Please contact Admin for info.
            </a>
          </v-layout>
        </v-card>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row>
        <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
          <ReportListHeading/>
          <v-data-table
          :headers="headers"
          :items="getSearchResults"
          class="elevation-1"
          :total-items=this.maxRows
          :hide-actions=this.hideActions
          >
           <template slot="items" slot-scope="props">
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item0 }}
             </td>
             <td class="text-xs-left">
               <!-- TAG or Type -->
               {{ defineTableContent(props.item).item1 }}
             </td>
             <!-- TITLE -->
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item2 }}
            </td>
            <!-- TYPE -->
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item3 }}
             </td>
             <td class="text-xs-left">
               {{ defineTableContent(props.item).item4 }}
             </td>
             <td class="text-xs-left">
               <span :class="defineTableContent(props.item).item5.colorText">
                 {{ defineTableContent(props.item).item5.title }}
               </span>
             </td>
             <td class="text-xs-left">
               <span :class="defineTableContent(props.item).item6.colorText">
                 {{ defineTableContent(props.item).item6.title }}
               </span>
             </td>
             <td class="text-xs-left">
               <span :class="defineTableContent(props.item).item7.colorText">
                 {{ defineTableContent(props.item).item7.title }}
               </span>
             </td>
             <td class="text-xs-right">
               <v-layout row>
                 <v-spacer/>
                 <RegisterRead :listIndex="props.index"
                 v-if="true"/>
                 <div :class="ui.textSubheadingBold"
                 v-if="props.item.basic.tag === 'A1'">
                   {{props.item.stats.na1}}
                 </div>
               </v-layout>
             </td>
           </template>
         </v-data-table>
         <ReportListBottom/>
         <v-layout class="mb-4"/>
         <v-layout class="mb-2"/>
       </v-flex>
      </v-layout>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import RegisterRead from "@/data/register/components/RegisterRead";
import ReportListHeading from "@/engineering/report/components/ReportListHeading";
import ReportListBottom from "@/engineering/report/components/ReportListBottom";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import reportFunctions from "@/engineering/report/mixins/reportFunctions";

export default {
  components: {
    RegisterRead,
    ReportListHeading,
    ReportListBottom
  },
  mixins: [
    dateFunctions,
    numberFunctions,
    apptheme,
    getList,
    displayFunctions,
    reportFunctions
  ],
  data() {
    return {
      maxRows: -1,
      btnSpinLoadMore: false,
      hideActions: true,
      barMovement: false,
      facilitySelect: false,
      localRead: false,
      enableProgressBar: true
    };
  },
  props: {
    date: {
      type: Object
    }
  },
  mounted() {
    setTimeout(() => {
      this.localRead = true;
      this.$store.dispatch("changeSearchResultsCounter", 0);
      this.$store.dispatch("changeSearchResultsCounter", 10);
    }, 500);
  },
  methods: {
    defineID(num) {
      return this.defineIDGShortLastSix(num);
    },
    switchLocalRead() {
      this.localRead = true;
    },
    defineTableContent(item) {
      let obj = {
        item0: "", // this is id
        item1: "",
        item2: "",
        item3: "",
        item4: "",
        item5: "",
        item6: "",
        item7: "",
        item8: ""
      };
      // DEFINE Stamdad
      obj.item0 = this.displayDocumentIDGTypeA(item.basic.tag, item.basic.idg);
      obj.item1 = item.link.aid;
      obj.item2 = item.basic.title;
      obj.item3 = item.char.type;
      obj.item4 = this.dateTypeA(item.stats.dcrt);
      if (item.result !== undefined) {
        obj.item5 = this.generateResultVisual(item.result[0]);
        obj.item6 = this.generateResultVisual(item.result[1]);
        obj.item7 = this.generateResultVisual(item.result[2]);
      }
      return obj;
    }
  },
  beforeMount() {
    this.$store.dispatch("changeSearchResultsCounter", 0);
    this.$store.dispatch("changeSearchResultsCounter", 10);
  },
  // updated() {
  //   this.$store.dispatch("chnageSearchResultsCounter", 0);
  // },
  computed: {
    ...mapGetters([
      "getSearchResults",
      "getSearchResultsCounter",
      "getPageTitle",
      "getRegisterInfo"
    ]),
    tag() {
      let tag = null;
      if (this.getSearchResults !== null) {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    dis() {
      let tag = null;
      if (this.getSearchResults !== null) {
        tag = this.getSearchResults[0].char.dis;
      }
      return tag;
    },
    headers() {
      let table = [
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "NA", sortable: false },
        { text: "", sortable: false, align: "right" }
      ];
      if (this.tag === "E8") {
        table[0].text = "ID";
        table[1].text = "Asset";
        table[2].text = "Result";
        table[3].text = "Type";
        table[4].text = "Date";
        table[5].text = "R1";
        table[6].text = "R2";
        table[7].text = "R3";
      }
      return table;
    }
  }
};
</script>
